/* eslint-disable promise/param-names */
import { MSG_TOTAL, MSG_SHOW, MSG_NOT_SHOW, MSG_GET_ALL, MSG_GET_USER, MSG_SEND, MSG_DEL_ID } from '../actions/messages'
import { AUTH_REQUEST_DONE, AUTH_REQUEST, AUTH_ERROR } from '../actions/auth'
import axios from 'axios'

const state = {
  messageShow: false,
  messagesTotal: 2,
  userMessagesTotal: 2,
  messages: [],
  userMessages: []
}

const getters = {
  messageShow: state => state.messageShow,
  messages: state => state.messages,
  userMessages: state => state.userMessages
}

const actions = {
  [MSG_GET_ALL]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      var tokexx = localStorage.getItem('user-token');
      axios.defaults.headers.common['Authorization'] = tokexx;

      var userIdd = localStorage.getItem('user-id');

      axios.post('https://api.personalizedenglish.com.br/messages/findbyall', {"userId": userIdd})
  /*axios({
      method: 'post',
      url: 'https://api.personalizedenglish.com.br/users/messages',
      withCredentials: true,
      crossdomain: true,
      data: {"merda": "oie"},
      headers: {
        "Content-Type": "'application/json;charset=UTF-8",
        "authorization": localStorage.getItem('user-token')
      }
    })*/
        .then(resp => {
//        var total =
//        if(resp.data.){ return false}else{return true}
//        commit(MSG_GET, resp)
        console.log('resp MSG_GET', resp)
        console.log('resp MSG_GET', resp.data.messages.length)
        commit(MSG_GET_ALL, resp.data.messages)
        commit(MSG_TOTAL, resp.data.messages.length)
        if(resp.data.messages.length>0){
            console.log('commit(MSG_SHOW)')
           commit(MSG_SHOW) }else{
             console.log('commit(MSG_NOT_SHOW)')
             commit(MSG_NOT_SHOW) }
        dispatch(AUTH_REQUEST_DONE)
        resolve(resp)
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        reject(err)
      })
    })
  },
  [MSG_GET_USER]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      var tokexx = localStorage.getItem('user-token');
      axios.defaults.headers.common['Authorization'] = tokexx;

      var userIdd = localStorage.getItem('user-id');

      axios.post('https://api.personalizedenglish.com.br/messages/findbyuser', {"userId": userIdd})
        .then(resp => {
        commit(MSG_GET_USER, resp.data.messages)
        commit(MSG_TOTAL, resp.data.messages.length)
        if(resp.data.messages.length>0){
            console.log('commit(MSG_SHOW)')
           commit(MSG_SHOW) }else{
             console.log('commit(MSG_NOT_SHOW)')
             commit(MSG_NOT_SHOW) }
        dispatch(AUTH_REQUEST_DONE)
        resolve(resp)
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        reject(err)
      })
    })
  },
  [MSG_DEL_ID]: ({commit, dispatch}, msgId) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      var tokexx = localStorage.getItem('user-token');
      axios.defaults.headers.common['Authorization'] = tokexx;

      var userIdd = localStorage.getItem('user-id');

      axios.post('https://api.personalizedenglish.com.br/messages/deletebyid', {"userId": userIdd, "msgId": msgId})
        .then(resp => {

          if(localStorage.getItem('user-degree')==='admin'){
            dispatch(MSG_GET_ALL)
          }else{
            dispatch(MSG_GET_USER)
          }

        dispatch(AUTH_REQUEST_DONE)
        resolve(resp)
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        reject(err)
      })
    })
  },
  [MSG_NOT_SHOW]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(MSG_NOT_SHOW)
      resolve()
    })
  },
  [MSG_SHOW]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(MSG_SHOW)
      resolve()
    })
  },
  [MSG_TOTAL]: ({commit, dispatch}, total) => {
    return new Promise((resolve, reject) => {
      commit(MSG_TOTAL, total)
      resolve()
    })
  }
}

const mutations = {
  [MSG_GET_USER]: (state, messages) => {
    state.userMessages = messages
  },
  [MSG_GET_ALL]: (state, messages) => {
    state.messages = messages
  },
  [MSG_TOTAL]: (state, total) => {
    state.userMessagesTotal = total
  },
  [MSG_SHOW]: (state) => {
    state.messageShow = true
  },
  [MSG_NOT_SHOW]: (state, total) => {
    state.messageShow = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/messages.js